import {
  ExternalBookingAPIKey,
  ExternalBookingAPIKeyCreationResponse,
} from '@models/ExternalBookingAPIKey'
import { APIResponse } from '@supplement-bacon/react-toolkit/models'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import { EXTERNAL_BOOKING_API_KEYS_URL } from '@utils/urls'

const fetchExternalBookingAPIKeys = (params: TableParams) =>
  SBAPI.FetchPaginated<ExternalBookingAPIKey[]>(
    EXTERNAL_BOOKING_API_KEYS_URL,
    params
  )

const fetchExternalBookingAPIKeyById = (id: number, params?: TableParams) =>
  SBAPI.Fetch<ExternalBookingAPIKey>(
    `${EXTERNAL_BOOKING_API_KEYS_URL}/${id}`,
    params
  )

const createExternalBookingAPIKey = (
  externalBookingAPIKey: ExternalBookingAPIKey
) =>
  SBAPI.Post<
    ExternalBookingAPIKey,
    APIResponse<ExternalBookingAPIKeyCreationResponse>
  >(EXTERNAL_BOOKING_API_KEYS_URL, externalBookingAPIKey)

const updateExternalBookingAPIKey = (
  externalBookingAPIKey: Partial<ExternalBookingAPIKey>
) =>
  SBAPI.Put(
    `${EXTERNAL_BOOKING_API_KEYS_URL}/${externalBookingAPIKey.id}`,
    externalBookingAPIKey
  )

const deleteExternalBookingAPIKey = (
  externalBookingAPIKey: ExternalBookingAPIKey
) =>
  SBAPI.Delete(`${EXTERNAL_BOOKING_API_KEYS_URL}/${externalBookingAPIKey.id}`)

export {
  createExternalBookingAPIKey,
  deleteExternalBookingAPIKey,
  fetchExternalBookingAPIKeyById,
  fetchExternalBookingAPIKeys,
  updateExternalBookingAPIKey,
}
